module.exports = __webpack_public_path__ + "static/media/Logo_circle.24f55fc1.png";